import { Star, Quote } from "lucide-react";

const testimonials = [
  {
    name: "Cynthia Peterson",
    role: "Homeowner",
    quote: "We had the pleasure of dealing with Luminate Media this Spring while selling our home. They not only accommodated our timeline, they were meticulous with the staging all the while being so friendly and professional. The pictures came out incredible!",
    rating: 5,
  },
  {
    name: "Seiler Home Group",
    role: "Real Estate Team",
    quote: "Our team has been working with Luminate Media for over 5 years now and we are always impressed with their amazing care for detail, professionalism, communication, and timeliness. Their work is astounding! The lighting and quality of the pictures are the best we can find!",
    rating: 5,
  },
  {
    name: "Amera Property Management",
    role: "Property Management",
    quote: "Jordan did a great job photographing a home for my real estate listing. He was able to take photos on a tight timeline and emailed them to me the next day. Gorgeous photos that made my listing look amazing! In less than 24 hours, we had three offers well above the asking price.",
    rating: 5,
  },
  {
    name: "Terry Kellum",
    role: "Realtor, Arkansas",
    quote: "As a new realtor, I first met Jordan with Luminate Media while listing a home for a client. When I received the photos, I was absolutely blown away by the quality! The home hit the market and within just six days, we received a full-price offer. I like to joke that he made me famous, but the truth is, high-quality photos make a world of difference in real estate. Jordan and Luminate Media absolutely deserve this great review!",
    rating: 5,
  },
];

const TestimonialsSection = () => {
  return (
    <section className="py-24 bg-background">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-primary font-medium tracking-[0.2em] uppercase text-sm mb-4">
            Testimonials
          </p>
          <h2 className="font-serif text-3xl md:text-5xl font-semibold text-foreground mb-6">
            Trusted by Top Agents
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Hear from real estate professionals who have elevated their listings with Luminate Media.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="relative p-8 rounded-lg bg-card border border-border hover:border-primary/30 transition-all duration-300"
            >
              <Quote className="absolute top-6 right-6 text-primary/20" size={40} />
              
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="fill-primary text-primary" size={18} />
                ))}
              </div>
              
              <p className="text-foreground mb-6 leading-relaxed">
                "{testimonial.quote}"
              </p>
              
              <div className="border-t border-border pt-4">
                <p className="font-serif font-semibold text-foreground">
                  {testimonial.name}
                </p>
                <p className="text-sm text-muted-foreground">
                  {testimonial.role}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
